/**
 * Storage utility - Web implementation using localStorage
 * Structure ready for Capacitor Preferences (to be added later)
 */

/**
 * Get storage value
 * @param {string} key - Storage key
 * @returns {string|null} - Stored value or null
 */
export function getStorageSync(key) {
  try {
    return localStorage.getItem(key)
  } catch (error) {
    console.error('Error getting storage:', error)
    return null
  }
}

/**
 * Set storage value
 * @param {string} key - Storage key
 * @param {string} value - Value to store
 */
export function setStorageSync(key, value) {
  try {
    if (value === null || value === undefined) {
      localStorage.removeItem(key)
    } else {
      localStorage.setItem(key, String(value))
    }
  } catch (error) {
    console.error('Error setting storage:', error)
  }
}

/**
 * Remove storage value
 * @param {string} key - Storage key
 */
export function removeStorageSync(key) {
  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.error('Error removing storage:', error)
  }
}

/**
 * Clear all storage
 */
export function clearStorageSync() {
  try {
    localStorage.clear()
  } catch (error) {
    console.error('Error clearing storage:', error)
  }
}

/**
 * Get a boolean storage value (localStorage stores strings)
 * @param {string} key - Storage key
 * @param {boolean} defaultValue - Default when missing
 * @returns {boolean}
 */
export function getBooleanStorageSync(key, defaultValue = false) {
  const value = getStorageSync(key)
  if (value === null || value === '') {
    return defaultValue
  }
  return value === true || value === 'true'
}

// Export as default object for compatibility
export default {
  getStorageSync,
  setStorageSync,
  removeStorageSync,
  clearStorageSync,
  getBooleanStorageSync,
}

